import { supabase } from "@/lib/supabase/supabaseClient";
import { EditQuestionProps } from ".";

export const editQuestion = async ({data}: EditQuestionProps) => {
    if(!data.id) throw new Error("Missing Question ID");

    const editedQuestionData = await supabase
        .from('question')
        .select('*')
        .eq('id', data.id)
        .maybeSingle()
        .throwOnError()
        .then(res => res.data);

    if (!editedQuestionData) {
        throw new Error("Question not found");
    }

    if (editedQuestionData.crm_system !== data.crm_system && data.crm_system) {
        const field_type_context_stack = [
            ...editedQuestionData.field_type_context_stack,
            {
                crm_system: data.crm_system,
                field_type: data.field_type!
            }
        ];
        return await supabase
            .from('question')
            .update({
                ...data,
                field_type_context_stack
            })
            .eq('id', data.id)
            .select()
            .maybeSingle()
            .throwOnError()
            .then(res => res.data);
    } else {
        return await supabase
            .from('question')
            .update(data)
            .eq('id', data.id)
            .select()
            .maybeSingle()
            .throwOnError()
            .then(res => res.data);
    }
}